
    const data = {"name":"src/core/icons/vector-line","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M15 3v4.59L7.59 15H3v6h6v-4.58L16.42 9H21V3m-4 2h2v2h-2M5 17h2v2H5\"/>","originalColors":[],"stopColors":[]}}

            export default data
            